import { Component, OnInit } from '@angular/core';
import { Config } from 'src/app/models/configuration.model';
import { ContentService } from 'src/app/services/content.service';
import { MultimodalService } from 'src/app/services/multimodal.service';

@Component({
  selector: 'app-teaching',
  templateUrl: './teaching.component.html',
  styleUrls: ['./teaching.component.css']
})
export class TeachingComponent implements OnInit {

  courses = [];
  config: Config;

  constructor(private contentService: ContentService, private multimodalService: MultimodalService) {
    this.config = multimodalService.config;
    this.config.activePage = 'teaching';
  }




  linkTo(url: string) {
    this.multimodalService.playAudioClick();
    this.multimodalService.playHapticButtonClick(150);
    setTimeout(() => window.open(url, '_blank'), 500);
  }

  ngOnInit() {
    this.contentService.getCourses().subscribe(res => {
      this.courses = res;
    });
  }


}
